module.exports = __webpack_public_path__ + "static/img/publicity2.62c4f2cc.jpg";